export class ContactoModel{
    idJardin:number;
    asunto:string;
    consulta:string;

    constructor(){
        this.idJardin = 0;
        this.asunto = null;
        this.consulta = null;
    }
}

export class ContactoTutorModel{
    idPersonaPeriodo:number;
    asunto:string;
    consulta:string;

    constructor(){
        this.idPersonaPeriodo = 0;
        this.asunto = null;
        this.consulta = null;
    }
}

export class ResponseForoModel{
    payload:ForoModel[];

    constructor(){
        this.payload = new Array<ForoModel>();
    }
}
export class ForoModel{   
    idForo:number;
    nombre:string;
    cantRespuestas:number;
    asunto:string;
    fecha:Date;

    constructor(){
        this.idForo = 0;
        this.nombre = '';
        this.cantRespuestas = 0
        this.asunto = '';
        this.fecha = null;
 
    }
}


export class ResponseDetalleConsultaModel{
    payload:DetalleConsultaModel;

    constructor(){
        this.payload = new DetalleConsultaModel();
    }
}

export class DetalleConsultaModel{   
    idForo:number;
    asunto:string;
    fecha:Date;
    nombres: string;
    pregunta: string;
    respuestas:  RespuestaModel[];
    usuario: string

    constructor(){
        this.idForo = 0;
        this.asunto = '';
        this.fecha = null;
        this.nombres =  '';
        this.pregunta =  '';
        this.respuestas =  new Array<RespuestaModel>();
        this.usuario =  ''
 
    }
}

export class RespuestaModel{   
    fecha: Date;
    nombre: string
    respuesta: string;
    usuario: string;

    constructor(){
        this.fecha = null;
        this.nombre = ''
        this.respuesta = '';
        this.usuario = '';
 
    }
}
 